import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Loader2, ShieldCheck } from "lucide-react";

const ACTION_COLOR = {
  create: "bg-emerald-100 text-emerald-700",
  update: "bg-blue-100 text-blue-700",
  delete: "bg-red-100 text-red-700",
  login: "bg-slate-100 text-slate-700",
  logout: "bg-slate-100 text-slate-700",
  upload: "bg-amber-100 text-amber-700",
  download: "bg-amber-50 text-amber-700",
  validate: "bg-emerald-100 text-emerald-700",
  approve: "bg-emerald-100 text-emerald-700",
  pay: "bg-emerald-100 text-emerald-700",
  register: "bg-blue-100 text-blue-700",
  ai_query: "bg-purple-100 text-purple-700",
  ai_generate_convention: "bg-purple-100 text-purple-700",
};

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs", { params: { limit: 300 } })
      .then(({ data }) => setItems(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="audit-page">
      <PageHeader
        title="Journal d'audit"
        subtitle="Traçabilité complète des actions sur la plateforme — conformité ESS et RGPD."
      />
      {loading ? <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-[#C5A059]" /></div> :
       items.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 p-12 text-center">
          <ShieldCheck className="h-10 w-10 mx-auto text-slate-300" /><p className="mt-3 text-slate-500">Aucune entrée.</p>
        </div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 border-b border-slate-200"><tr className="text-left text-xs uppercase tracking-wider text-slate-500"><th className="px-4 py-3">Horodatage</th><th className="px-4 py-3">Acteur</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Ressource</th><th className="px-4 py-3">Détails</th></tr></thead>
            <tbody>{items.map(l => (
              <tr key={l.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 text-xs text-slate-500 font-mono">{l.created_at?.slice(0,19).replace("T", " ")}</td>
                <td className="px-4 py-3 text-slate-700 text-xs">{l.actor_email || "—"}</td>
                <td className="px-4 py-3"><span className={`text-[11px] px-2 py-1 rounded ${ACTION_COLOR[l.action] || "bg-slate-100 text-slate-700"}`}>{l.action}</span></td>
                <td className="px-4 py-3 text-slate-600 text-xs">{l.resource}</td>
                <td className="px-4 py-3 text-slate-500 text-xs truncate max-w-md">{l.meta ? JSON.stringify(l.meta) : "—"}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </div>
  );
}
